module.exports = __webpack_public_path__ + "img/Gruppenführer_Sp.1e52ebc9.svg";